import dayjs from 'dayjs';

export const SUPPORTED_LOCALES = <const>[
  'ru',
  'en', // English
  'pt-BR', // Portuguese Brazil
  'tr', // Turkish
  'uk', // Ukrainian
  'pl', // Polish
  'cs', // Czech
  'fr', // French
  'de', // German
  'pt', // Portuguese
  'ro', // Romanian
  'es', // Spanish
  'sv' // Swedish
];

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const LOCALE_NAMES: Record<SupportedLocale, string> = {
  ru: 'Русский',
  en: 'English',
  'pt-BR': 'Portuguese (Brazil)',
  tr: 'Türkçe',
  uk: 'Українська',
  pl: 'Polski',
  cs: 'Český',
  fr: 'Français',
  de: 'Deutsch',
  pt: 'Português',
  ro: 'Română',
  es: 'Español',
  sv: 'Svensk'
};

// for performance reasons and because of how webpack works
// we need to flood with else if statements
export async function registerDayjsLocale(locale: SupportedLocale): Promise<void> {
  let localeData: Function;

  if ('ru' === locale) {
    localeData = async () => import('dayjs/locale/ru');
  } else if ('en' === locale) {
    localeData = async () => import('dayjs/locale/en');
  } else if ('pt-BR' === locale) {
    localeData = async () => import('dayjs/locale/pt');
  } else if ('tr' === locale) {
    localeData = async () => import('dayjs/locale/tr');
  } else if ('uk' === locale) {
    localeData = async () => import('dayjs/locale/uk');
  } else if ('pl' === locale) {
    localeData = async () => import('dayjs/locale/pl');
  } else if ('cs' === locale) {
    localeData = async () => import('dayjs/locale/cs');
  } else if ('fr' === locale) {
    localeData = async () => import('dayjs/locale/fr');
  } else if ('de' === locale) {
    localeData = async () => import('dayjs/locale/de');
  } else if ('pt' === locale) {
    localeData = async () => import('dayjs/locale/pt');
  } else if ('ro' === locale) {
    localeData = async () => import('dayjs/locale/ro');
  } else if ('es' === locale) {
    localeData = async () => import('dayjs/locale/es');
  } else if ('sv' === locale) {
    localeData = async () => import('dayjs/locale/sv');
  } else {
    throw new Error(`Unsupported locale: ${locale}`);
  }

  dayjs.locale(await localeData());
}
